import {TaskResource} from "../../../../client/resources/taskResource";
import {DeploymentResource} from "../../../../client/resources/deploymentResource";
import {Filter, getQuery} from "areas/tasks/components/Tasks/Tasks";
import {convertQueryToQueryString} from "components/QueryStringFilters/QueryStringFilters";

export default (root: string) => {
    const taskRoot = `${root}/tasks`;
    return {
        tasks: {
            root: taskRoot,
            console: `${taskRoot}/console`,
            filtered: (tasksFilter: Filter) => {
                const queryString = convertQueryToQueryString(getQuery(tasksFilter));
                return `${taskRoot}${queryString}`;
            }
        },
        task: (taskId: string | TaskResource<any> | DeploymentResource) => {
            if (!!taskId && typeof taskId !== "string") {
                taskId = isDeploymentResource(taskId) ? taskId.TaskId : taskId.Id;
            }
            return {
                root: `${taskRoot}/${taskId}`,
                raw: `${taskRoot}/${taskId}/raw`,
            };
        }
    };
};

function isDeploymentResource(resource: TaskResource<any> | DeploymentResource): resource is DeploymentResource {
    return !!(resource as DeploymentResource).TaskId;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/areas/tasks/components/TaskRoutes/taskRouteLinks.ts